export default "/_next/static/data/personalization-hero-lottie.json-151f161ad952dd813784f94bba63d5cf.json";